/* eslint-disable react-hooks/exhaustive-deps */

import { Grid } from "@material-ui/core"
import { Modal, InputTextMaster, MasterButton } from "App/Component/ui"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants"
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  titleModal,
} from "App/utils/helpers"
import React, { useContext, useEffect, useState } from "react"
import { getTotal, getTotalFilterID, isExist } from "../.."
import { FormContext } from "../../../context/FormContext"
import { v4 as uuidv4 } from "uuid"
import { MSG_NOT_MINUS, itSelfEmpty } from "utils/all"
import PilihDokter from "../../SelectOption/PilihDokter"

export const urlGetPaketByKelas = "/penjualan/listPaketByKelasId"
export const urlDelete = "/penjualan/deletePaket"
export const urlGet = "/penjualan/listPaketByPenjualanId"

export const RESET_STATE_DAFTAR_PAKET = {
  id: "",
  mh_paket_id: "",
  paket_id: "",
  qty: "",
  keterangan: "",
  harga: "",
  hargaCustom: "",
  hargaCustom2: "",
  kelas_id: "",

  namaPaket: "",

  doctor_id: null,
  doctor_name: "Pilih Dokter",
}

export const deletePaketById = async (formData) => {
  try {
    const res = await instance3.post(urlDelete, formData)

    if (res.data.status === 200) {
      return {
        state: true,
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getPaketByPenjualanID = async (id) => {
  try {
    const res = await instance3.get(`${urlGet}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        message: res.data.message,
      }
    } else if (res.data.status === 204) {
      return {
        state: true,
        data: [],
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "40px",
  },
  {
    id: "namaPaket",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "harga_jual",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaJsPaket",
    disablePadding: false,
    label: "JENIS",
    align: "left",
    minWidth: "100px",
  },
]

export const getAllPaketByKelas = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.post(`${urlGetPaketByKelas}`, {
      kelasId: formFilter.kelas_id,
      asuransiId: formFilter.asuransi_id,
      namaPaket: formFilter.name,
      id_gudang: itSelfEmpty(formFilter.id_gudang),
      halaman: pages,
      jumlah: limit,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
      data: [],
      meta: {
        count: 0,
        pages: 1,
        limit: 10,
      },
    }
  }
}

export const ModalDaftarPaket = ({
  setShowModal,
  formPaket,
  setFormPaket,
  setNewPaketDijual,
  setNewDataPaketByKelas,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const { formData, setFormData } = useContext(FormContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (isNull(formPaket.qty)) {
        defaultToastError("Qty harus diisi")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        if (isNull(formPaket.doctor_id)) {
          defaultToastError("Dokter tidak boleh kosong")
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        } else {
          if (convertToValidPrice(formPaket.qty) > 0) {
            if (isNull(formPaket.id)) {
              const checkExist = isExist(
                formData.paket,
                "mhPaketId",
                formPaket.mh_paket_id,
              )
              if (checkExist) {
                setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
                return defaultToastError("Paket ini sudah ada di list")
              } else {
                await addPaket()
              }
            } else {
              const filterPaket = formData.paket.filter(
                (e) => e.id !== formPaket.id,
              )
              const newSinglePaket = setSinglePaket("UPDATE")
              const newPaket = [...filterPaket, newSinglePaket]
              if (!isNull(formData.penjualan_id)) {
                await addPaketServer(newSinglePaket, "/penjualan/updatePaket")
                setShowModal(false)
              } else {
                setShowModal(false)
                setNewPaketDijual(newPaket, false)
                defaultToastSuccess("Berhasil mengubah list paket")
              }
            }
          } else {
            if (convertToValidPrice(formPaket.qty) < 0) {
              defaultToastError(MSG_NOT_MINUS)
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
            } else if (convertToValidPrice(formPaket.qty) === 0) {
              defaultToastError("QTY tidak boleh 0")
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
            } else if (isNull(formPaket.hargaCustom)) {
              defaultToastError("Harga harus diisi")
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
            } else {
              defaultToastError("Inputan tidak valid")
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
            }
          }
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    setFormPaket({
      ...formPaket,
      hargaCustom: convertToValidPrice(formPaket.hargaCustom2),
    })
  }, [formPaket.hargaCustom2])

  const setSinglePaket = (type) => {
      const qty = convertToValidPrice(formPaket.qty)

    const singlePaket = {
      mhPaketId: formPaket.mh_paket_id,
      qty: qty,
      keterangan: "",
      harga: formPaket.harga,
      hargaCustom: formPaket.hargaCustom,
      hargaCustom2: formPaket.hargaCustom2,
      total: formPaket.hargaCustom * qty,

      namaPaket: formPaket.namaPaket,
      paket_id: formPaket.paket_id,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,

      doctor_id: formPaket.doctor_id,
      doctor_name: formPaket.doctor_name,
    }

    let newSinglePaket
    if (type === "ADD") {
      newSinglePaket = {
        id: uuidv4(),
        ...singlePaket,
      }
    } else {
      newSinglePaket = {
        id: formPaket.id,
        ...singlePaket,
      }
    }

    return newSinglePaket
  }

  const addPaket = async () => {
    const newSinglePaket = setSinglePaket("ADD")
    const newPaket = [...formData.paket, newSinglePaket]

    if (!isNull(formData.penjualan_id)) {
      await addPaketServer(newSinglePaket, "/penjualan/addPaket")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    } else {
      await setFormData({
        ...formData,
        paket: newPaket,
      })
      defaultToastSuccess("Berhasil menambah paket")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    }
    setNewPaketDijual(newPaket, false)
  }

  const addPaketServer = async (paket, url) => {
    try {
      const totalPaket = await getTotalFilterID(
        formData.paket,
        paket.id,
        "paket",
      )
      const hargaTotalPaket = paket.qty * paket.hargaCustom + totalPaket

      const totalBarang = getTotal(formData.barang, "barang")
      const totalRikjang = getTotal(formData.rikjang, "rikjang")
      const totalJasa = getTotal(formData.jasa, "jasa")
      const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")
      const jumlah =
        totalBarang +
        totalRikjang +
        hargaTotalPaket +
        totalJasa +
        totalFasilitas

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const newPaket = {
        ...paket,
        penjualanId: formData.penjualan_id,
        harga_total_paket: convertToValidPrice(hargaTotalPaket),
        total_Penjualan: convertToValidPrice(jumlah),
        sisa: convertToValidPrice(total),

        tax: taxPercent,
        jumlah_tax: convertToValidPrice(taxNumber),
        discount: convertToValidPrice(formData.potongan / total),
        jumlah_set_discount: potongan,
      }
      const res = await instance3.post(url, newPaket)
      if (res.data.status === 200) {
        defaultToastSuccess(res.data.message)
        await setNewPaketDijual(newPaket, false)
        setNewDataPaketByKelas()
      } else {
        defaultToastError(res.data.message)
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  return (
    <Modal title={`${titleModal(formPaket.id)} Paket`} show={setShowModal}>
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <p className="mt-1 mb-1">{formPaket.namaPaket}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formPaket.id}
          />
          <Grid item sm={4}>
            <InputTextMaster
              name="qty"
              label="BANYAK"
              id="qty"
              value={formPaket.qty}
              onChange={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormPaket({
                    ...formPaket,
                    qty: formatRupiah(val),
                  })
                } else {
                  setFormPaket({
                    ...formPaket,
                    qty: val,
                  })
                }
              }}
              placeholder="Banyak"
              autoFocus={true}
            />
          </Grid>

          <Grid item sm={4}>
            <InputTextMaster
              name="harga"
              label="HARGA"
              id="harga"
              placeholder="0"
              value={formPaket.hargaCustom2}
              onInput={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormPaket({
                    ...formPaket,
                    hargaCustom2: formatRupiah(val),
                  })
                } else {
                  setFormPaket({
                    ...formPaket,
                    hargaCustom2: val,
                  })
                }
              }}
            />
          </Grid>

          <Grid item sm={4}>
            <PilihDokter formData={formPaket} setFormData={setFormPaket} />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name="discount-paket"
              label="DISKON (%)"
              id="discount-paket"
              value={formPaket.diskon}
              onChange={(e) => {
                const raw = e.target.value
                if (raw === "") {
                  return setFormPaket({ ...formPaket, diskon: "" })
                }
                if (/^[0-9]*([.,][0-9]*)?$/.test(raw)) {
                  if (convertToValidPrice(raw) > 100) {
                    return setFormPaket({ ...formPaket, diskon: 100 })
                  } else {
                    return setFormPaket({
                      ...formPaket,
                      diskon: formatRupiah(raw),
                    })
                  }
                }
              }}
              placeholder="15"
              error={convertToValidPrice(formPaket.diskon) > 100}
              message="Maksimal 100%"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  )
}
